"use strict";
/*
 * Created on 25. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var DataUploadConverter_1 = require("../../data-upload/conversions/DataUploadConverter");

var UploadValidityEnum_1 = require("../../data-upload/model/UploadValidityEnum");

var ProductPricesUpload_1 = require("../model/ProductPricesUpload");

var ProductPricesUploadConverter_1 = require("./ProductPricesUploadConverter");
/**
 * Default implementation of {@link ProductPricesUploadConverter}.
 *
 * @author Radek Beran
 */


var ProductPricesUploadConverterImpl =
/*#__PURE__*/
function (_ProductPricesUploadC) {
  _inherits(ProductPricesUploadConverterImpl, _ProductPricesUploadC);

  function ProductPricesUploadConverterImpl() {
    _classCallCheck(this, ProductPricesUploadConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductPricesUploadConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(ProductPricesUploadConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ProductPricesUpload_1.ProductPricesUpload(ProductPricesUpload_1.ProductPricesUpload.schema.id.valueOf(conversions.documentToClassId(source)), utils_1.Utils.isValueMissing(source.releaseId) ? null : ProductPricesUpload_1.ProductPricesUpload.schema.releaseId.valueOf(conversions.toClassReferenceId(source.releaseId)), ProductPricesUpload_1.ProductPricesUpload.schema.date.valueOf(conversions.toDate(source.date)), ProductPricesUpload_1.ProductPricesUpload.schema.validity.valueOf(conversions.asEnum(source.validity, UploadValidityEnum_1.UploadValidityEnum)), ProductPricesUpload_1.ProductPricesUpload.schema.importedRowsCount.valueOfField(source), utils_1.Utils.isValueMissing(source.progressMonitorId) ? null : ProductPricesUpload_1.ProductPricesUpload.schema.progressMonitorId.valueOf(conversions.toClassReferenceId(source.progressMonitorId)), conversions.asObjectList(source, 'notifications', DataUploadConverter_1.DataUploadConverter.deserializeNotification(conversions)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        date: conversions.fromDate(source.date),
        validity: source.validity,
        importedRowsCount: source.importedRowsCount,
        progressMonitorId: conversions.toDocumentReferenceId(source.progressMonitorId),
        notifications: conversions.asObjectArray(source, 'notifications', DataUploadConverter_1.DataUploadConverter.serializeNotification(conversions))
      });
      return document;
    }
  }]);

  return ProductPricesUploadConverterImpl;
}(ProductPricesUploadConverter_1.ProductPricesUploadConverter);

exports.ProductPricesUploadConverterImpl = ProductPricesUploadConverterImpl;